<div class="search-box-wide arrow-right eip-mt-20 eip-ml-0 eip-mr-0 eip-pxy-20 reset-row">
  <div class="d-block d-sm-none">
      <i class="fa fa-times-circle close-btn" (click)="closeAdvanceSearch($event)" aria-hidden="true"></i>
  </div>
  <form [formGroup]="searchForm">
      <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width:100%;">
                  <mat-label>Free Search</mat-label>
                  <input matInput formControlName="ctrlSearchText">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete id="actxtwarehouse" WaterMarkText="Type *" TextField="description" ValueField="value" [selectedIndex]=selectedTypeIndex [defaultValue]=selectedTypeValue ShowTextValueField='N' [dataSource]='searchTypeList' formControlName="ctrlType">
              </EIPAutoComplete>
          </div>
          <div class="eip-pr-20 adv-srch-btns eip-ml-auto eip-mt-10">
              <div class="btn-group eip-ml-20">
                  <button type="button" class="btn btn-primary" (click)="insertSavedSearch()">Save & Search</button>
                  <button type="button" class="savesearch" *ngIf="hasSavedSearch" (click)="showInfo($event)"><i class="fa fa-angle-down" aria-hidden="true"></i>
                  </button>
              </div>
              <input type="submit" value="Search" (click)="searchData()" class="btn btn-primary eip-ml-20" id="btnSearch">
          </div>
      </div>
  </form>
  <kendo-popup class="order-popup" popupClass="kendo-popup kendo-popup-left kp-pos-left" [anchor]="anchorElementPopup" [anchorAlign]="anchorAlignLeft" [popupAlign]="popupAlignLeft" (anchorViewportLeave)="IsShowPopup = false" *ngIf="IsShowPopup" (click)="closePopup()">
      <div class="kp-body" *ngFor="let search of savedSearchList; let index = index">
          <div class="search-row">
              <p class="font-weight-bold">{{search.searchName}}<span class="float-right">
                      <i class="fa fa-pencil eip-mr-5" (click)="editSavedSearch(search)" aria-hidden="true"></i>
                      <i class="fa fa-trash" (click)="removeSavedSearch(search.searchId)" aria-hidden="true"></i></span></p>
          </div>
      </div>
  </kendo-popup>
</div>